import { h } from 'preact';
import { ui } from '@playkit-js/kaltura-player-js';
import { IconSizes } from '../../types/icon-sizes';
import { PLUGIN_ICON_PATH } from '../../components/icons';
import * as styles from './plugin-button.scss';
import { clsx } from 'clsx';

const { Tooltip, Icon } = ui.components;

interface Props {
  isActive: boolean;
  setRef: (ref: HTMLButtonElement | null) => void;
  label: string;
}
export const PluginButton = ({ label, isActive, setRef }: Props): h.JSX.Element => {
  return (
    <Tooltip label={label} type="bottom">
      <button
        ref={(node) => {
          setRef(node);
        }}
        className={clsx(ui.style.upperBarIcon, styles.pluginButton, isActive ? styles.active : '')}
        type="button"
      >
        <Icon
          height={IconSizes.Big}
          id="pluginName"
          path={PLUGIN_ICON_PATH}
          viewBox={`0 0 ${IconSizes.Big} ${IconSizes.Big}`}
          width={IconSizes.Big}
        />
      </button>
    </Tooltip>
  );
};
